import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo" onClick={(e) => {
          closeMenu();
          if (location.pathname === '/') {
            window.location.reload();
          } else {
            window.location.href = '/';
          }
        }}>
          <span className="logo-text">FalconDev</span>
          <span className="logo-team">Team</span>
        </div>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <div
            className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={(e) => {
              closeMenu();
              if (location.pathname === '/') {
                window.location.reload();
              } else {
                window.location.href = '/';
              }
            }}
          >
            Home
          </div>
          <Link
            to="/about"
            className={`navbar-link ${location.pathname === '/about' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            About
          </Link>
          <Link
            to="/storm-dash"
            className={`navbar-link ${location.pathname === '/storm-dash' ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Storm Dash
          </Link>
          <div
            className={`navbar-link ${location.pathname === '/blog' ? 'active' : ''}`}
            onClick={() => {
              closeMenu();
              window.open('https://teamfalcondevs.blogspot.com/?m=1', '_blank');
            }}
            style={{ cursor: 'pointer' }}
          >
            Blog
          </div>
        </div>

        <div className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
